import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "lib-input-code",
  templateUrl: "./input-code.component.html",
  styleUrls: ["./input-code.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class InputCodeComponent implements OnChanges {
  @Input() size: number = 4;
  @Input() class: string = "";
  @Input() loading: boolean = false;
  @Input() success: boolean = false;
  @Input() error: boolean = false;
  @Input() bus = new EventEmitter<string>();
  @Output() codeResult: EventEmitter<any> = new EventEmitter();
  @Output() codeClear: EventEmitter<any> = new EventEmitter();

  public numbers: any[] = new Array(this.size).fill("");
  private values: any[] = new Array(this.size).fill("");
  private destroy = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.bus.pipe(takeUntil(this.destroy)).subscribe((data: string) => {
      if (data.length === this.size) {
        this.numbers = data.split("");
        this.values = data.split("");
        this.codeResult.emit(this.values);
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["error"]?.currentValue) {
      setTimeout(() => {
        this.codeClear.emit();
        this.numbers = [];
        setTimeout(() => {
          this.numbers = new Array(this.size).fill("");
          this.values = new Array(this.size).fill("");
          this.cdr.markForCheck();
        }, 30);
      }, 2000);
    }
  }

  onInputChange(event: any, index: number, item: any) {
    const inputValue: string = event?.target?.value?.toString?.() || "";
    const lastChar = inputValue.charAt(inputValue.length - 1) || "";
    if (/^\d$/.test(lastChar)) {
      event.target.value = lastChar;
      this.values[index] = lastChar;
      this.cdr.markForCheck();
    } else {
      this.numbers = [];
      setTimeout(() => {
        this.numbers = new Array(this.size).fill("");
        this.values = new Array(this.size).fill("");
        this.cdr.markForCheck();
        setTimeout(() => {
          const listInput = document.getElementsByName("lib-input-tag-code");
          listInput[0].focus();
        }, 30);
      }, 30);
    }
  }

  onKeyDown(event: any, index: number): void {
    const listInput = document.getElementsByName("lib-input-tag-code");

    const key = event.key;
    setTimeout(() => {
      if (/^\d$/.test(key)) {
        if (index < this.numbers.length - 1) {
          const nextInput = listInput[index + 1];
          if (nextInput) {
            nextInput.focus();
          }
          this.codeResult.emit(this.values);
        } else {
          this.codeResult.emit(this.values);
        }
      }
    }, 20);
  }

  public get classes(): string[] {
    let status = "";

    if (this.success) {
      status = "lib-border-success";
    } else if (this.error) {
      status = "lib-border-error";
    } else if (this.loading) {
      status = "lib-border-primary";
    }

    return [status, "lib-input-code ", "lib-p-1-4", "lib-mr-1-4"].filter(Boolean);
  }
  public get classesContainer(): string[] {
    return ["lib-input-container-code", this.class].filter(Boolean);
  }
}
